import { useState, useRef } from 'react';
import { useSafeLayoutEffect } from './useSafeLayoutEffect';
export const useConsistentCursor = (onChange, ref, value = '') => {
  const [currentValue, setCurrentValue] = useState('');
  const cursorRef = useRef(value === null || value === void 0 ? void 0 : value.length);
  const handleChange = e => {
    cursorRef.current = e.target.selectionStart;
    setCurrentValue(e.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  useSafeLayoutEffect(() => {
    if (currentValue.length !== value.length) {
      cursorRef.current += value.length - currentValue.length;
      setCurrentValue(value);
    }
    if (ref.current && cursorRef.current) {
      ref.current.selectionEnd = cursorRef.current;
    }
  }, [ref, currentValue, value]);
  return handleChange;
};